import { render } from "./level-4.vue?vue&type=template&id=1645f8ac&ts=true"
import script from "./level-4.vue?vue&type=script&lang=ts"
export * from "./level-4.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__